class CampsiteReviews extends HTMLElement {
  connectedCallback () {
    const reviews = this.querySelectorAll('.campsite__review-item')

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const ratingRect = entry.target.querySelector('rect[fill="black"]')
          if (ratingRect) {
            const animateEl = ratingRect.querySelector('animate')
            const finalWidth = animateEl.getAttribute('to')

            // Start the animation
            animateEl.beginElement()

            // After animation completes, set the final width and remove animate element
            setTimeout(() => {
              ratingRect.setAttribute('width', finalWidth)
              animateEl.remove()
            }, 600)
          }
          observer.unobserve(entry.target)
        }
      })
    }, {
      threshold: 0.2,
      rootMargin: '0px',
    })

    reviews.forEach(review => observer.observe(review))
  }
}

if (!customElements.get('campsite-reviews')) {
  customElements.define('campsite-reviews', CampsiteReviews)
}
